<template>
  <svg :class='rotate' width="16" height="12" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7501 0.750044L1.25006 0.750045C1.11338 0.750473 0.9794 0.78817 0.86255 0.859079C0.7457 0.929986 0.650401 1.03142 0.58691 1.15246C0.523419 1.2735 0.494143 1.40957 0.50223 1.54601C0.510317 1.68245 0.555462 1.8141 0.632807 1.9268L7.38281 11.6768C7.66256 12.081 8.33606 12.081 8.61656 11.6768L15.3666 1.92679C15.4447 1.81434 15.4905 1.68262 15.499 1.54595C15.5076 1.40928 15.4785 1.27289 15.4149 1.15159C15.3514 1.03029 15.2558 0.928728 15.1386 0.857935C15.0214 0.787143 14.887 0.749827 14.7501 0.750044Z" />
  </svg>
</template>

<script>
export default {
  name: "TriangleIcon",
  props: {
    rotate: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  fill: inherit
}

.up {
  transform: rotate(180deg);
}

.down {
  transform: rotate(0deg);
}

.left {
  transform: rotate(90deg)
}

.right {
  transform: rotate(270deg)
}
</style>